module.exports = __webpack_public_path__ + "img/ORDER-LIVE.71abc810.png";